module.exports = __webpack_public_path__ + "img/thumb_24.a0ded929.jpg";